var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapSearchresultItemSection = function SvgLivemapSearchresultItemSection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "Component 110 \\u2013 5",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4da5b5",
    d: "M2 2h1.808v1.808H2zm16.272 0v1.808h1.808V2zm0 18.08h1.808v-1.808h-1.808zM2 20.08h1.808v-1.808H2zM8.328 4.712h9.04v9.04h-3.616v3.616h-9.04v-9.04h3.616zm4.52 9.04h-4.52v-4.52H5.616v7.232h7.232zM9.232 8.328h4.52v4.52h2.712V5.616H9.232zm0 4.52h3.616V9.232H9.232z",
    "data-name": "Rectangle 4789"
  })));
};
export default SvgLivemapSearchresultItemSection;